export const API_ENDPOINT = "https://api.firsttrackit.com:8082/api/v1";
export const API_ENDPOINT_V2 = "https://api.firsttrackit.com:8082/api/v2";

